import { atom } from 'jotai'
import { GetRequestCachedV3 } from '../api'
import { API_CACHE_DURATION, urls } from '../constants'
import { alertAtom, globalLoaderAtom } from './globalStateAtoms'

export const ownChildBranchesAtoms = atom([])
export const getOwnChildBranchesAtoms = atom(null, async (get, set, data) => {
    try {
        set(globalLoaderAtom, true)
        const res = await GetRequestCachedV3(urls.getOwnAndChildBranchList, data,true,API_CACHE_DURATION)
        set(globalLoaderAtom, false)
        if (res.status === 'Success') {
            set(ownChildBranchesAtoms, res.Data.Table)
        } else {
            set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server', nextId: '' })
            set(ownChildBranchesAtoms, [])
        }
    } catch (error) {
        console.error(error)
        set(ownChildBranchesAtoms, [])
    }
})


